import { SVGProps, Ref, forwardRef } from 'react';

export const TrolleybusFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22 21.08c0 .857 0 1.286-.13 1.628-.203.536-.626.96-1.162 1.162-.342.13-.771.13-1.629.13-.766 0-1.15 0-1.468-.11a2 2 0 0 1-1.14-1.006c-.12-.247-.175-.547-.242-1.065-1.166.134-2.561.181-4.229.181s-3.063-.047-4.23-.18c-.067.517-.12.817-.242 1.064a2 2 0 0 1-1.14 1.006c-.317.11-.7.11-1.467.11-.858 0-1.287 0-1.629-.13a2 2 0 0 1-1.162-1.162C2 22.366 2 21.937 2 21.079V13.3h20zM6.75 15.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m10.5 0a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M9.8 17.65h4.4v-1.8H9.8z"
            fill="currentColor"
        />
        <path
            d="M6.343 2.417c.531-.122 1.125-.21 1.79-.274L7.56 0h1.863l.544 2.03Q10.907 2 12 2c8.405 0 9.89 1.153 9.993 9H22v.5H2V11h.007c.06-4.538.581-6.838 2.637-7.97L3.833 0h1.863z"
            fill="currentColor"
        />
    </svg>
));
TrolleybusFilledSize24Glyph.displayName = 'TrolleybusFilledSize24Glyph';
